'use client'
import Link from 'next/link'
import React from 'react'
import styles from './TemporaryBlankHeader.module.scss'
import { LogoSize, LogoSurface, LogoVariant, MainLogo } from '@/tools/ui'

type Props = {
  logoSize?: LogoSize
}
export const TemporaryBlankHeader: React.FC<Props> = ({ logoSize }) => (
  <header className={styles.tempHeader}>
    <Link href="/">
      <MainLogo
        className={styles.logoImage}
        size={logoSize || LogoSize.medium}
        surface={LogoSurface.onPrimary}
        variant={LogoVariant.logotype}
      />
    </Link>
  </header>
)
